import AgentHubEarnYourOwnTourModal from 'agentHub/components/AgentHubEarnYourOwnTourModal'
import { isAgentHubEarnYourOwnTourModalDismissed } from 'agentHub/storage/agentHubEarnYourOwnTourModalStorage'
import { isAgentHubEnabled } from 'agentHub/selectors/isAgentHubEnabled'
import ModalContext from 'contexts/ModalContext'
import { useAppSelector } from 'hooks/reduxHooks'
import { useContext, useEffect, useRef, useState } from 'react'
import { selectLoggedIn } from 'selectors/accountSelectors'

function useAgentHubEarnYourOwnTourLoginModal() {
  const showModal = useContext(ModalContext)
  const loggedIn = useAppSelector(selectLoggedIn)
  const initComplete = useAppSelector(state => state.auth.initComplete)
  const hasShown = useRef(false)
  const [canShowAfterLogin, setCanShowAfterLogin] = useState(false)

  useEffect(() => {
    // Only arm once auth bootstrap has settled. A silent OIDC session restore
    // flips loggedIn from false to true while initComplete is still false, and
    // that rehydration must not be treated as a fresh login that shows the promo.
    if (!loggedIn && initComplete) {
      setCanShowAfterLogin(true)
    }
  }, [loggedIn, initComplete])

  useEffect(() => {
    if (!isAgentHubEnabled) return
    if (!loggedIn) return
    if (!canShowAfterLogin) return
    if (hasShown.current) return
    if (isAgentHubEarnYourOwnTourModalDismissed()) return

    hasShown.current = true
    showModal(<AgentHubEarnYourOwnTourModal />)
  }, [showModal, loggedIn, canShowAfterLogin])
}

export default useAgentHubEarnYourOwnTourLoginModal
